export default "__VITE_PUBLIC_ASSET__02d3b1b4__"